import { render, staticRenderFns } from "./positionSelect.vue?vue&type=template&id=4c1a81a0"
import script from "./positionSelect.vue?vue&type=script&lang=js"
export * from "./positionSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports